<template>
  <div class="questao mb-5">
    <div class="img-questao text-center" v-if="questao.imagens && questao.imagens.length">
      <img v-for="imagem in questao.imagens"
           :src="obterCaminhoImagem(imagem)"
           alt="Texto explicando imagem detalhadamente"
           class="img-fluid d-inline-block m-3"/>
    </div>
    <vue-mathjax class="enunciado mt-4 mb-3" :safe="false" :formula="questao.enunciado" :options="mathJaxOptions"></vue-mathjax>
    <div class="respostas mt-4">
      <div class="custom-control custom-checkbox" v-for="(opcao, index) in questao.opcoes">
        <input type="checkbox" class="custom-control-input" :id="`resposta${index}`" :value="opcao.id" v-model="respostaQuestao" @click="singleCheckbox(opcao)" :disabled="questao.opcaoEscolhida > 0">
        <label class="custom-control-label" :for="`resposta${index}`" :class="classOpcaoQuestao(opcao)">{{ `${opcao.letra}. ${opcao.texto}` }}</label>
      </div>
    </div>
    <div class="btns-prev-next d-flex mt-4 mb-3">
      <a href="javascript:void(0)" @click="responder()" class="btn btn-step mr-3" :class="{disabled: this.questao.opcaoEscolhida}">Responder</a>
      <a href="javascript:void(0)" @click="limpar()" class="btn btn-step mr-3">Limpar</a>
    </div>

    <b-alert id="alertaQuestao" :variant="alerta.variant" dismissible :show="alerta.visivel" @dismissed="alerta.visivel=false">
      <div v-html="alerta.mensagem"></div>
    </b-alert>

    <div class="comentario" v-if="questao.opcaoEscolhida && hideComentario">
      <p>Comentário</p>
      <div>
        <p v-html="questao.comentario"></p>
        <div class="mt-3" v-if="questao.imagensComentario && questao.imagensComentario.length">
          <a v-for="(imagem, index) in questao.imagensComentario" href="javascript:void(0)" @click="abrirModalImagemComentario(imagem)"><i class="fas fa-image"></i> {{ `Imagem ${index + 1}` }}</a>
        </div>
      </div>
    </div>

    <b-modal hide-footer id="modalComentario">
      <template slot="modal-title">
        <h5 class="modal-title" id="modalComentarioLabel">Comentário</h5>
      </template>
      <div class="text-center">
        <div class="my-3" v-if="imagemModal">
          <img :src="imagemModal" alt="Texto explicando imagem detalhadamente" class="img-fluid" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import QuestoesAPI from '@/api/questoes-api'
import ResponseUtils from '@/core/utils/response-utils'
import SalaAulaAPI from '@/api/sala-aula-api'
import ImageUtils from '@/core/utils/image-utils'

export default {
  name: 'TopicoQuestaoObjetiva',
  props: {
    ementaCurso: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      mathJaxOptions: {
        tex2jax: {
          inlineMath: [['$', '$']],
          displayMath: [['$$', '$$']],
          processEscapes: true,
          processEnvironments: true
        }
      },
      alerta: {
        variant: '',
        mensagem: '',
        visivel: false
      },
      respostaQuestao: [],
      imagemModal: '',
      questao: {
        ementaId: 0,
        enunciado: '',
        opcoes: [],
        titulo: '',
        comentario: '',
        opcaoCorreta: 0,
        opcaoEscolhida: 0,
        imagens: [],
        imagensComentario: []
      }
    }
  },
  methods: {

    obterCaminhoImagem: function (imagem) {
      return ImageUtils.obterUrlCompletaImagem(`${imagem}`, 'questoes-imagem/')
    },

    abrirModalImagemComentario: function (imagem) {
      this.imagemModal = this.obterCaminhoImagem(imagem)
      this.$bvModal.show('modalComentario')
    },

    classOpcaoQuestao: function (opcao) {
      if (this.questao.opcaoEscolhida) {
        if (opcao.id === this.questao.opcaoCorreta) {
          return 'text-success'
        } else if (opcao.id === this.questao.opcaoEscolhida) {
          return 'text-danger'
        }
      }
      return ''
    },

    adicionarOpcaoQuestao: function (id, letra, opcao) {
      if (opcao && opcao !== null) {
        this.questao.opcoes.push({ id: id, letra: letra, texto: opcao })
      }
    },

    obterTopico: function () {
      this.alerta = { visivel: false, mensagem: '' }

      this.questao = {
        ementaId: this.ementaCurso.topico_escolhido.ementa_id,
        enunciado: this.ementaCurso.topico_escolhido.enunciado,
        titulo: this.ementaCurso.topico_escolhido.titulo,
        comentario: this.ementaCurso.topico_escolhido.comentario_feedback,
        opcaoCorreta: this.ementaCurso.topico_escolhido.opcao_correta,
        opcaoEscolhida: this.ementaCurso.topico_escolhido.opcao_respondida,
        imagens: this.ementaCurso.topico_escolhido.imagem_enunciado,
        imagensComentario: this.ementaCurso.topico_escolhido.imagem_comentario
      }

      this.questao.opcoes = []
      this.adicionarOpcaoQuestao(1, 'a', this.ementaCurso.topico_escolhido.resposta1)
      this.adicionarOpcaoQuestao(2, 'b', this.ementaCurso.topico_escolhido.resposta2)
      this.adicionarOpcaoQuestao(3, 'c', this.ementaCurso.topico_escolhido.resposta3)
      this.adicionarOpcaoQuestao(4, 'd', this.ementaCurso.topico_escolhido.resposta4)
      this.adicionarOpcaoQuestao(5, 'e', this.ementaCurso.topico_escolhido.resposta5)

      this.respostaQuestao = [this.ementaCurso.topico_escolhido.opcao_respondida]
    },

    singleCheckbox: function (opcao) {
      this.respostaQuestao = [opcao.id]
    },

    limpar: function () {
      const loader = this.$loading.show()

      QuestoesAPI.limparRespostaQuestao(this.questao.ementaId).then(() => {
        this.questao.opcaoEscolhida = 0
        this.respostaQuestao = []
        this.alerta = {}

        loader.hide()
      })
    },

    responder: function () {
      if (!this.respostaQuestao || !this.respostaQuestao.length || !this.respostaQuestao[0]) {
        this.alerta = {
          visivel: true,
          variant: 'danger',
          mensagem: '<strong>Obrigatório selecionar uma opção antes de responder!</strong>'
        }
      } else {
        const loader = this.$loading.show()

        QuestoesAPI.atualizarRespostaQuestao(this.questao.ementaId, this.respostaQuestao[0]).then(() => {
          this.questao.opcaoEscolhida = this.respostaQuestao[0]

          this.alerta = {
            visivel: true,
            variant: this.questao.opcaoEscolhida === this.questao.opcaoCorreta ? 'success' : 'danger',
            mensagem: this.questao.opcaoEscolhida === this.questao.opcaoCorreta ? '<strong>Parabéns! Você acertou!</strong>.' : '<strong>Que pena! Você errou.</strong>.'
          }

          loader.hide()
        }).catch(error => ResponseUtils.handleError(error, loader))
          .then(() => {
            SalaAulaAPI.atualizarVisualizacaoTopico(this.ementaCurso.topico_escolhido.ementa_id, 1).then(() => {
              this.$store.dispatch('ementaIdConcluida', this.ementaCurso.topico_escolhido.ementa_id)
            })
          })
      }
    }
  },
  mounted () {
    this.obterTopico()
  },

  watch: {
    ementaCurso: function () {
      this.obterTopico()
    }
  },
  computed: {
    hideComentario: function () {
      if (this.questao.comentario || this.questao.imagensComentario.length > 0) {
        return true
      } else {
        return false
      }
    }
  }
}

</script>

<style scoped>

</style>
